import { enrollmentConstants } from './constants/enrollmentConstants';

const getEnrollment = () => ({
  type: enrollmentConstants.getEnrollmentRequest,
}); 

const getEnrollmentParams = (data: any) => ({
  type: enrollmentConstants.getEnrollmentParamsRequest,
  payload: data,
});

const getEnrollmentView = (data: any) => ({
  type: enrollmentConstants.enrollmentViewRequest,
  payload: data,
});

const createEnrollment = (data: any) => ({
  type: enrollmentConstants.createEnrollmentRequest,
  payload: data,
});

const deleteEnrollment = (data: any) => ({
  type: enrollmentConstants.deleteEnrollmentRequest,
  payload: data,
});

const resetCreateEnrollment = () => ({
  type: enrollmentConstants.createEnrollmentReset,
});

const resetDeleteEnrollment = () => ({
  type: enrollmentConstants.deleteEnrollmentReset,
});

const toggleEnrollment = (data: any) => ({
  type: enrollmentConstants.enrollmentToggleRequest,
  payload: data,
});

const exportEnrollment = (data: any) => ({
  type: enrollmentConstants.exportEnrollmentRequest,
  payload: data,
});

const assignApplication = (data: any) => ({
  type: enrollmentConstants.assignApplicationRequest,
  payload: data,
});

const resetAssignApplication = () => ({
  type: enrollmentConstants.assignApplicationReset,
});

export const enrollmentActions = {
  getEnrollment,
  getEnrollmentParams,
  getEnrollmentView,
  createEnrollment,
  deleteEnrollment,
  toggleEnrollment,
  exportEnrollment,
  resetCreateEnrollment,
  resetDeleteEnrollment,
  assignApplication,
  resetAssignApplication,
};
